import styled from 'styled-components';

export const Title = styled.div`
    background-color: ${(props) => props.bgTitle};
    /* height: 10vh; */
    padding: 0;
    color: white;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    font-size: xxx-large;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
`;